import React from "react";
import { Helmet } from "react-helmet";
import { useStore } from "../../context/StoreContext";
import { useStorefrontTheme } from "../../shared/theme/storefrontTheme";
import "./comingSoonPage.css";

/* Matches the reference storefront's holding page (SP-main storefront-shell.js comingSoon()):
   the store's logo or initial, its name, a "Coming soon" badge and one line — nothing to browse. */
const BADGE = "Coming soon";
const MESSAGE = "We’re putting together the products we recommend — check back shortly.";

const ComingSoon = () => {
  const { storeDetails, pageDetails } = useStore();
  const appearance = pageDetails?.page_data?.colorAndApperances || {};
  // The designer saves the headline style as `storefrontStyle`; the theme reads `style`.
  const sfxRef = useStorefrontTheme({ ...appearance, style: appearance.storefrontStyle || appearance.style });

  const name = storeDetails?.store_name || "This store";
  const logo = storeDetails?.store_logo || pageDetails?.page_data?.logoIdentity?.storeLogo;
  const initial = name.trim().charAt(0).toUpperCase() || "S";

  return (
    <div ref={sfxRef} className="sfx">
      <Helmet>
        <title>{`${name} — ${BADGE}`}</title>
      </Helmet>
      <div className="sf-soon">
        {/* Cream only until the store loads, so a default initial and colour never flash. */}
        {storeDetails && (
        <div className="sf-soon-card">
          {logo ? (
            <img className="soon-logo" src={logo} alt={name} />
          ) : (
            <div className="soon-disc" aria-hidden="true">{initial}</div>
          )}
          <h1 className="soon-name">{name}</h1>
          <div className="soon-badge">{BADGE}</div>
          <p className="soon-msg">{MESSAGE}</p>
        </div>
        )}
      </div>
    </div>
  );
};

export default ComingSoon;
